"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonTypes_de_de = void 0;
function commonTypes_de_de() {
    return {
        "types.primitives.boolean": "richtig/falsch",
        "types.primitives.string": "Zeichenkette",
        "types.primitives.number": "Zahl",
        "types.customtype.singular": "Projektspezifischer Typ",
        "types.customtype.plural": "Projektspezifische Typen",
        "types.customers.singular": "Kunde",
        "types.customers.plural": "Kunden",
        "types.applications.singular": "Anwendung",
        "types.applications.plural": "Anwendungen",
        "types.auditlog_records.singular": "Audit-Log",
        "types.auditlog_records.plural": "Audit-Logs",
        "types.subscriptions_booked.singular": "Gebuchtes Abonnement",
        "types.subscriptions_booked.plural": "Gebuchte Abonnements",
        "types.calendars.singular": "Kalender",
        "types.calendars.plural": "Kalender",
        "types.calendarentries.singular": "Termin",
        "types.calendarentries.plural": "Termine",
        "types.cmspages.singular": "CMS Seite",
        "types.cmspages.plural": "CMS Seiten",
        "types.companies.singular": "Firma",
        "types.companies.plural": "Firmen",
        "types.configurations.singular": "Konfiguration",
        "types.configurations.plural": "Konfigurationen",
        "types.contact_customfields.singular": "Benutzerdefiniertes Kontaktfeld",
        "types.contact_customfields.plural": "Benutzerdefinierte Kontaktfelder",
        "types.contacts.singular": "Kontakt",
        "types.contacts.plural": "Kontakte",
        "types.counters.singular": "Zähler",
        "types.counters.plural": "Zähler",
        "types.countries.singular": "Land",
        "types.countries.plural": "Länder",
        "types.cronjobs.singular": "Geplante Aufgabe",
        "types.cronjobs.plural": "Geplante Aufgaben",
        "types.custombackoffices.singular": "Projektspezifisches Backoffice",
        "types.custombackoffices.plural": "Projektspezifische Backoffices",
        "types.dashboards.singular": "Dashboard",
        "types.dashboards.plural": "Dashboards",
        "types.datatypes.singular": "Datentyp",
        "types.datatypes.plural": "Datentypen",
        "types.data.singular": "Daten",
        "types.data.plural": "Daten",
        "types.device_registrations.singular": "Geräteregistrierung",
        "types.device_registrations.plural": "Geräteregistrierungen",
        "types.devices.singular": "Gerät",
        "types.devices.plural": "Geräte",
        "types.emaillayouts.singular": "Email Layout",
        "types.emaillayouts.plural": "Email Layouts",
        "types.emailtemplates.singular": "Email Vorlage",
        "types.emailtemplates.plural": "Email Vorlagen",
        "types.emails.singular": "Email",
        "types.emails.plural": "Emails",
        "types.files.singular": "Datei",
        "types.files.plural": "Dateien",
        "types.forms.singular": "Formular",
        "types.forms.plural": "Formulare",
        "types.invitations.singular": "Einladung",
        "types.invitations.plural": "Einladungen",
        "types.languages.singular": "Sprache",
        "types.languages.plural": "Sprachen",
        "types.locales.singular": "Gebietsschema",
        "types.locales.plural": "Gebietsschemas",
        "types.mailing_channels.singular": "Mailing Kanal",
        "types.mailing_channels.plural": "Mailing Kanäle",
        "types.mailing_deliverable.singular": "Mailing Zustellung",
        "types.mailing_deliverable.plural": "Mailing Zustellungen",
        "types.mailing_lists.singular": "Mailing Liste",
        "types.mailing_lists.plural": "Mailing Listen",
        "types.mailing_sent.singular": "Gesendetes Mailing",
        "types.mailing_sent.plural": "Gesendetes Mailings",
        "types.messages.singular": "Nachricht",
        "types.messages.plural": "Nachrichten",
        "types.notes.singular": "Notiz",
        "types.notes.plural": "Notizen",
        "types.notifications.singular": "Benachrichtigung",
        "types.notifications.plural": "Benachrichtigungen",
        "types.optins.singular": "Opt-In",
        "types.optins.plural": "Opt-Ins",
        "types.orders.singular": "Bestellung",
        "types.orders.plural": "Bestellungen",
        "types.permissions.singular": "Berechtigung",
        "types.permissions.plural": "Berechtigungen",
        "types.pricezones.singular": "Preis Zone",
        "types.pricezones.plural": "Preis Zonen",
        "types.products.singular": "Produkt",
        "types.products.plural": "Produkte",
        "types.datatemplates.singular": "Daten Vorlage",
        "types.datatemplates.plural": "Daten Vorlagen",
        "types.projects.singular": "Projekt",
        "types.projects.plural": "Projekte",
        "types.resellers.singular": "Reseller",
        "types.resellers.plural": "Resellers",
        "types.roles.singular": "Rolle",
        "types.roles.plural": "Rollen",
        "types.servicetokens.singular": "Servicetoken",
        "types.servicetokens.plural": "Servicetoken",
        "types.shoppingcarts.singular": "Warenkorb",
        "types.shoppingcarts.plural": "Warenkörbe",
        "types.subscriptions.singular": "Abonnement",
        "types.subscriptions.plural": "Abonnements",
        "types.suppliers.singular": "Zulieferer",
        "types.suppliers.plural": "Zulieferer",
        "types.tasks.singular": "Aufgabe",
        "types.tasks.plural": "Aufgaben",
        "types.translations.singular": "Übersetzung",
        "types.translations.plural": "Übersetzungen",
        "types.todos.singular": "Aufgabe",
        "types.todos.plural": "Aufgaben",
        "types.todotemplates.singular": "Aufgabenvorlage",
        "types.todotemplates.plural": "Aufgabenvorlagen",
        "types.users.singular": "Backoffice Benutzer",
        "types.users.plural": "Backoffice Benutzer",
        "types.visitors.singular": "Besucher",
        "types.visitors.plural": "Besucher",
        "types.visitorevents.singular": "Besucher Event",
        "types.visitorevents.plural": "Besucherevents",
        "types.printerconfigurations.singular": "Drucker Konfiguration",
        "types.printerconfigurations.plural": "Drucker Konfigurationen",
        "types.apps.singular": "App",
        "types.apps.plural": "Apps",
        "types.workflows_executions.singular": "Workflow Ausführung",
        "types.workflows_executions.plural": "Workflow Ausführungen",
        "types.workflows.singular": "Workflow",
        "types.workflows.plural": "Workflows",
        "types.worklogs.singular": "Arbeitsprotokoll",
        "types.worklogs.plural": "Arbeitsprotokolle",
        "types.pdftemplates.singular": "PDF Vorlage",
        "types.pdftemplates.plural": "PDF Vorlagen"
    };
}
exports.commonTypes_de_de = commonTypes_de_de;
